export default __webpack_public_path__ + "static/google-play-5e52084f7cf296a285e59977bce5ca0d.svg";